<h1 mat-dialog-title>Erreur sur le client {{ client.name }}</h1>
<div mat-dialog-content class="error-list">
  <span *ngFor="let error of errors">
    {{ error.message }}
  </span>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="goToClient()">Fiche {{ getClientName() }}</button>
</div>